export const EXPERIMENT_HOMEPAGE_COOKIE_NAME = 'tz_newhomepage';
export const EXPERIMENT_HOMEPAGE_GROUP_OLD = `${EXPERIMENT_HOMEPAGE_COOKIE_NAME}0`;
export const EXPERIMENT_HOMEPAGE_GROUP_NEW = `${EXPERIMENT_HOMEPAGE_COOKIE_NAME}1`;

export const EXPERIMENT_RESUME_EVALUATION_COOKIE_NAME = 'tz_resume_evaluation';
export const EXPERIMENT_RESUME_EVALUATION_GROUP_0 = `${EXPERIMENT_RESUME_EVALUATION_COOKIE_NAME}0`;
export const EXPERIMENT_RESUME_EVALUATION_GROUP_1 = `${EXPERIMENT_RESUME_EVALUATION_COOKIE_NAME}1`;

export const RESUME_EVALUATION_FULL_PAGE_COOKIE_NAME =
  'tz_resume_evaluation_full_page';

export const EXPERIMENT_COMPANY_DETAIL_COOKIE_NAME = 'tz_company_detail';
export const EXPERIMENT_COMPANY_DETAIL_GROUP_0 = `${EXPERIMENT_COMPANY_DETAIL_COOKIE_NAME}0`;
export const EXPERIMENT_COMPANY_DETAIL_GROUP_1 = `${EXPERIMENT_COMPANY_DETAIL_COOKIE_NAME}1`;
